import { Component, Vue } from "vue-property-decorator";
import axios from "axios";
// Services
import { getBlockages } from "@/services/Blocking/blocking.service";
// Components
import { BlockingFilterBar } from "@/components/index";
// Entities
import { Warehouse, Blocking, Company, BlockingsFields } from "@/entities/index";

@Component({
  components: {
    BlockingFilterBar,
  },
})
export default class BlockingConsultation extends Vue {
  warehouses: Warehouse[] = [];
  blockings: Blocking[] = [];
  blockingsCSV: Blocking[] = [];

  client = this.company.codeLogistic;
  idCompany = this.company.id;
  integrateStepZero = this.company.integrateStepZero;

  blockingsFields: BlockingsFields = {
    reference: "",
    lot: "",
    warehouse: "",
    cause: "",
  };

  overlay = false;
  snackbarNoResults = false;

  headers = [
    {
      text: this.$t("Blocking.table.reference"),
      class: "indigo--text text--darken-4",
      align: "start",
      value: "reference",
    },
    {
      text: this.$t("Blocking.table.designation"),
      class: "indigo--text text--darken-4",
      value: "designation",
    },
    {
      text: this.$t("Blocking.table.lot"),
      class: "indigo--text text--darken-4",
      value: "lot",
    },
    {
      text: this.$t("Blocking.table.blockingQuantity"),
      class: "indigo--text text--darken-4",
      value: "blockingQuantity",
    },
    {
      text: this.$t("Blocking.table.blockingDate"),
      class: "indigo--text text--darken-4",
      value: "blockingDate",
    },
    {
      text: this.$t("Blocking.table.daysOfBlocking"),
      class: "indigo--text text--darken-4",
      value: "dayOfBlocking",
    },
    {
      text: this.$t("Blocking.table.warehouse"),
      class: "indigo--text text--darken-4",
      value: "warehouse",
    },
    {
      text: this.$t("Blocking.table.cause"),
      class: "indigo--text text--darken-4",
      value: "cause",
    },
  ];

  headersCSV = [
    {
      text: "Reference",
      value: "reference",
    },
    { text: "Designation", value: "designation" },
    { text: "Lot", value: "lot" },
    { text: "Quantite blocage", value: "blockingQuantity" },
    { text: "Date de blocage", value: "blockingDate" },
    { text: "Jours de blocage", value: "dayOfBlocking" },
    { text: "Entrepot", value: "warehouse" },
    { text: "Motif de blocage", value: "cause" },
  ];

  async loadBlockages(): Promise<void> {
    this.overlay = true;
    this.blockings = await getBlockages({
      client: this.client,
      integrateStepZero: this.integrateStepZero,
      userId: this.profile.id,
      blockingsFields: {
        reference:
          this.blockingsFields.reference === ""
            ? undefined
            : this.blockingsFields.reference,
        lot:
          this.blockingsFields.lot === ""
            ? undefined
            : this.blockingsFields.lot,
        warehouse:
          this.blockingsFields.warehouse === ""
            ? undefined
            : this.blockingsFields.warehouse,
        cause:
          this.blockingsFields.cause === ""
            ? undefined
            : this.blockingsFields.cause,
      },
    });
    this.overlay = false;
  }

  async search(blockingsFields: BlockingsFields): Promise<void> {
    this.blockingsFields = blockingsFields;
    await this.loadBlockages();
    if (this.blockings.length === 0) {
      this.snackbarNoResults = true;
    }
  }

  async allWarehouses(): Promise<void> {
    this.warehouses = (
      await axios.get(`/api/warehouses/company/${this.idCompany}`)
    ).data as Warehouse[];
  }

  mounted(): void {
    this.allWarehouses();
  }

  // ========== GETTERS ========== //

  get company(): Company {
    return this.$store.getters.company;
  }

  get profile() {
    return this.$store.getters.profile;
  }

  // ========== OTHERS METHODS ========== //

  colorRow(item: Blocking): any {
    const position = this.blockings.indexOf(item, 0);
    if (position % 2 == 0) {
      return "light-green lighten-5";
    }
  }

  goToTop(): void {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }

  // === EXPORT TO CSV === //

  async blockingCSV(): Promise<Blocking[]> {
    await this.loadBlockages();
    const blockingsCSV = this.blockings;
    const userId = this.profile.id;
    await axios.post("/api/stats/action", {
      userId,
      action: "Extraction des blocages en CSV",
    });
    return blockingsCSV;
  }

  convertToCSV(json: any): string {
    if (json.reference === null || json.reference === undefined) {
      json.reference = "";
    }
    if (json.designation === null || json.designation === undefined) {
      json.designation = "";
    }
    if (json.lot === null || json.lot === undefined) {
      json.lot = "";
    }
    if (json.blockingQuantity === null || json.blockingQuantity === undefined) {
      json.blockingQuantity = "";
    }
    if (json.blockingDate === null || json.blockingDate === undefined) {
      json.blockingDate = "";
    }
    if (json.dayOfBlocking === null || json.dayOfBlocking === undefined) {
      json.dayOfBlocking = "";
    }
    if (json.warehouse === null || json.warehouse === undefined) {
      json.warehouse = "";
    }
    if (json.cause === null || json.cause === undefined) {
      json.cause = "";
    }
    json.designation = json.designation.replace(/ /g, "");
    return `"${json.reference}";"${json.designation}";"${json.lot}";"${json.blockingQuantity}";"${json.blockingDate}";"${json.dayOfBlocking}";"${json.warehouse}";"${json.cause}"`;
  }

  downloadCSV(): void {
    const csvJSON = this.blockings.map((json: any) => this.convertToCSV(json));
    csvJSON.unshift(
      this.headersCSV.map((header: any) => header.text).join(";")
    );
    const csvData = csvJSON.join("\n");
    const csvBlob = new Blob([csvData], { type: "text/csv;charset=utf-8" });
    const csvUrl = URL.createObjectURL(csvBlob);
    const link = document.createElement("a");
    link.href = csvUrl;
    link.download = "Blocages.csv";
    link.click();
  }
}
